import * as yup from 'yup';

import { getEmptyErrorMessage } from 'coreOld/yup';
import { IRank } from 'system/types';

export const rankSchema: yup.SchemaOf<Omit<IRank, 'rankId'>> = yup.object().shape({
  rankName: yup.string().required(getEmptyErrorMessage('Name')),
});
